import { observable, action } from 'mobx'

class ErrorStore {
  @observable message = undefined
  @observable modalIsOpen = false
  @observable changePath = undefined
  @observable userError = false

  constructor() {
    this.displayerror = this.displayError.bind(this)
  }

  @action.bound displayError(message, userError = false) {
    this.message = message
    this.modalIsOpen = this.message !== undefined
    this.userError = userError
  }

  @action.bound close() {
    this.message = undefined
    this.modalIsOpen = false
  }
}

export default new ErrorStore()



// WEBPACK FOOTER //
// ./src/stores/errorStore.js